import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { adminMainUrl } from "../../../../Config";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  getBranchCountry,
  getBranchState,
  getBranchCity,
} from "../../../../Redux/action/Organisation/Branch/BranchAction";

const LedgerAccountAddress = ({
  ledger_account_id,
  addresses,
  onAddressChange,
  onAddNew,
  onRemove,
  saveAndNext,
  tabId,
  backId,
}) => {
  const dispatch = useDispatch();

  const {
    loadingBranchCountryApi,
    BranchCountryData = [], // array of countries

    loadingBranchStateApi,
    BranchStateData = [], // will be replaced per country

    loadingBranchCityApi,
    BranchCityData = [], // will be replaced per state
  } = useSelector((state) => state?.BranchReducer);

  // console.log("BranchCountryData", BranchCountryData);
  // const test=BranchCountryData?.find((item) => item.id == addresses.country)

  // Load countries once on mount
  useEffect(() => {
    if (!BranchCountryData?.length) {
      dispatch(getBranchCountry());
    }
  }, [dispatch, BranchCountryData?.length]);

  // Handle country change → load states
  const handleCountryChange = (index, e) => {
    const countryId = e.target.value; // assuming you're using numeric ID
    onAddressChange(index, {
      target: { name: "country", value: countryId },
    });

    // Reset dependent fields
    onAddressChange(index, { target: { name: "state", value: "" } });
    onAddressChange(index, { target: { name: "city", value: "" } });

    // find country ID ONLY for API call
    const countryObj = BranchCountryData.find((c) => c.name == countryId);
    // Load states for selected country
    if (countryObj?.id) {
      dispatch(getBranchState(countryObj.id));
    }
  };

  // Handle state change → load cities
  const handleStateChange = (index, e) => {
    const stateId = e.target.value;
    onAddressChange(index, {
      target: { name: "state", value: stateId },
    });

    // Reset city
    onAddressChange(index, { target: { name: "city", value: "" } });

    // find state ID ONLY for API call
    const stateObj = BranchStateData.find((s) => s.name === stateId);

    if (stateObj?.id) {
      dispatch(getBranchCity(stateObj.id));
    }
  };


  const validateAddresses = () => {
    if (addresses.length === 0) {
      toast.error("At least one address is required");
      return false;
    }

    for (let i = 0; i < addresses.length; i++) {
      const addr = addresses[i];

      if (!addr.address_line_one?.trim()) {
        toast.error(`Address Line 1 is required for address Form ${i + 1}`);
        return false;
      }

      if (!addr.country) {
        toast.error(`Country is required for address Form ${i + 1}`);
        return false;
      }

      // Optional: you can also require state depending on your business rules
      if (!addr.state) {
        toast.error(`State is required for address Form ${i + 1}`);
        return false;
      }
      if (!addr.city) {
        toast.error(`City is required for address Form ${i + 1}`);
        return false;
      }

      // Pincode is optional in most cases, but you can make it required:
      if (!addr.pincode?.trim()) {
        toast.error(`Pincode/ZIP is required for address Form ${i + 1}`);
        return false;
      }
    }

    return true;
  };

  const submitLedgerForm = async () => {
    // 1. Validate all addresses before API call
    if (!validateAddresses()) {
      return;
    }

    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/ledger-account`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"),
            user_id: Cookies.get("flexichain_user_id"),
          },
          body: JSON.stringify({
            ledger_account_id,
            address: addresses,
          }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        toast.success(data?.msg || "Address saved successfully");
        saveAndNext(tabId);
      } else {
        toast.error(data?.msg || "Failed to save address");
      }
    } catch (error) {
      toast.error("Network error occurred");
      console.error("Submit error:", error);
    }
  };

  const addNewAddressSection = () => {
    if (!validateAddresses()) {
      return;
    }
    onAddNew();
  };

  return (
    <>
      <style>{`
        .padding-pt-9 { padding: 10px; }
        .loading-select { opacity: 0.6; pointer-events: none; }
      `}</style>

      <h6 className="fw-semibold mb-3">Address Details</h6>

      {addresses?.map((item, index) => (
        <div
          key={index}
          className="row bg-white p-3 mb-4 position-relative shadow-sm rounded "
        >
          <div className="d-flex justify-content-end  mb-3">
            {index > 0 && (
              <button
                type="button"
                onClick={() => onRemove(index)}
                className="btn btn-primary "
                title="Remove this address"
              >
                <i className="fas fa-trash"></i>
              </button>
            )}
          </div>
          {/* Address Line 1 */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-medium">
              Address Line 1 <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="address_line_one"
              className="form-control bg-light"
              value={item.address_line_one || ""}
              onChange={(e) => onAddressChange(index, e)}
              placeholder="Enter Address Line 1"
            />
          </div>

          {/* Address Line 2 */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-medium">Address Line 2</label>
            <input
              type="text"
              name="address_line_two"
              className="form-control bg-light"
              value={item.address_line_two || ""}
              onChange={(e) => onAddressChange(index, e)}
              placeholder="Enter Address Line 2 (optional)"
            />
          </div>

          {/* Country */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-medium">
              Country <span className="text-danger">*</span>
            </label>
            <select
              name="country"
              className={`form-select bg-light padding-pt-9 ${
                loadingBranchCountryApi ? "loading-select" : ""
              }`}
              value={item.country || ""}
              onChange={(e) => handleCountryChange(index, e)}
              disabled={loadingBranchCountryApi}
            >
              <option value="">Select Country</option>
              {BranchCountryData &&
                BranchCountryData.map((country) => (
                  <option key={country.id} value={country.name}>
                    {country.name} ({country.sort_name})
                  </option>
                ))}
            </select>
          </div>

          {/* State */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-medium">
              State <span className="text-danger">*</span>
            </label>
            <select
              name="state"
              className={`form-select bg-light padding-pt-9 ${
                loadingBranchStateApi ? "loading-select" : ""
              }`}
              value={item.state || ""}
              onChange={(e) => handleStateChange(index, e)}
              disabled={!item.country || loadingBranchStateApi}
            >
              <option value="">Select State</option>
              {/* {BranchStateData &&
                BranchStateData.filter((s) => s.name == item.country).map(
                  (state) => (
                    <option key={state.id} value={state.id}>
                      {state.name}
                    </option>
                  ),
                )} */}
              {BranchStateData &&
                BranchStateData?.map((s) => (
                  <option key={s.id} value={s.name}>
                    {s.name}
                  </option>
                ))}
            </select>
          </div>

          {/* City */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-medium">
              City <span className="text-danger">*</span>
            </label>
            <select
              name="city"
              className={`form-select bg-light padding-pt-9 ${
                loadingBranchCityApi ? "loading-select" : ""
              }`}
              value={item.city || ""}
              onChange={(e) => onAddressChange(index, e)}
              disabled={!item.state || loadingBranchCityApi}
            >
              <option value="">Select City</option>
              {/* {BranchCityData &&
                BranchCityData?.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                ))} */}
              {BranchCityData &&
                BranchCityData?.map((c) => (
                  <option key={c.id} value={c.name}>
                    {c.name}
                  </option>
                ))}
            </select>
          </div>

          {/* Pincode */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-medium">Pincode / ZIP</label>
            <input
              type="text"
              name="pincode"
              className="form-control bg-light"
              value={item.pincode || ""}
              onChange={(e) => onAddressChange(index, e)}
              placeholder="Enter pincode / ZIP code"
            />
          </div>
        </div>
      ))}

      {/* Bottom Action Buttons */}
      {/* <div className="d-flex gap-3 mt-4 flex-wrap justify-content-between">
        <div className="d-flex gap-3 mt-4 flex-wrap">
          <button
            type="button"
            onClick={() => saveAndNext(backId)}
            className="btn btn-primary px-4"
          >
            Back
          </button>

          <button
            type="button"
            onClick={submitLedgerForm}
            className="btn btn-primary px-4"
          >
            <i className="fas fa-save me-1"></i> Save & Next
          </button>
        </div>

        <button
          type="button"
          className="btn btn-light px-4"
          onClick={() => addNewAddressSection()}
        >
          <i className="fas fa-plus me-1"></i> Add Another Address
        </button>
      </div> */}

      <div className="d-flex flex-wrap gap-3 justify-content-between mt-2">
        <div className="d-flex gap-3">
          <button
            type="button"
            className="btn btn-primary px-5"
            onClick={() => saveAndNext(backId)}
          >
            Back
          </button>

          <button
            type="button"
            className="btn btn-primary px-5"
            onClick={submitLedgerForm}
          >
            Save & Next
          </button>
        </div>

        <button
          type="button"
          className="btn btn-light px-4"
          onClick={addNewAddressSection}
        >
          <i className="fas fa-plus me-2"></i>Add Another Address
        </button>
      </div>
    </>
  );
};

export default LedgerAccountAddress;
